import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  loadDeductionCategories as loadDeductionCategoriesApi,
  loadAllDeductionCategories as loadAllDeductionCategoriesApi,
  saveDeductionCategory as saveDeductionCategoryApi,
  loadDeductionCategory as loadDeductionCategoryApi,
  updateDeductionCategory as updateDeductionCategoryApi,
  deleteDeductionCategory as deleteDeductionCategoryApi,
  loadDeductions as loadDeductionsApi,
  saveDeduction as saveDeductionApi,
  loadDeduction as loadDeductionApi,
  updateDeduction as updateDeductionApi,
  deleteDeduction as deleteDeductionApi,
  loadDeductionSettings as loadDeductionSettingsApi,
  loadDeductionSetting as loadDeductionSettingApi,
  addDeductionSetting as addDeductionSettingApi,
  updateDeductionSetting as updateDeductionSettingApi,
  deleteDeductionSetting as deleteDeductionSettingApi,
  loadAllDeductions as loadAllDeductionsApi,
  loadEmployeeAssignedDeduction as loadEmployeeAssignedDeductionApi,
  assignDeductionToEmployee as assignDeductionToEmployeeApi,
  deleteDeductionFromEmployee as deleteDeductionFromEmployeeApi,
  disableDeductionFromEmployee as disableDeductionFromEmployeeApi,
  loadAllBonuses as loadAllBonusesApi,
  assignBonusToEmployee as assignBonusToEmployeeApi,
  deleteBonusFromEmployee as deleteBonusFromEmployeeApi,
  disableBonusFromEmployee as disableBonusFromEmployeeApi,
  loadEmployeeAssignedBonus as loadEmployeeAssignedBonusApi,
  updateAssignedBonus as updateAssignedBonusApi,
  loadBackupHistory as loadBackupHistoryApi,
  downloadBackup as downloadBackupApi,
  recordBackup as recordBackupApi,
  loadPaySlipHistory as loadPaySlipHistoryApi,
  loadAllPaySlipHistory as loadAllPaySlipHistoryApi,
  runPayRoll as runPayRollApi,
  loadEmployeePaySlipDetails as loadEmployeePaySlipDetailsApi,
  getPaySlipList as getPaySlipListApi,
  getContributionTypes as getContributionTypesApi,
  getSalaryTypes as getSalaryTypesApi,
  getCNPSReport as getCNPSReportApi,
  generateEmployeePayslip as generateEmployeePayslipApi,

  //Bonus Settings
  loadBonusSettings as loadBonusSettingsApi,
  loadBonusSetting as loadBonusSettingApi,
  addBonusSetting as addBonusSettingApi,
  updateBonusSetting as updateBonusSettingApi,
  deleteBonusSetting as deleteBonusSettingApi,
  validatePayslips as validatePayslipsApi,
  rejectPayslips as rejectPayslipsApi,

  //Allowances
  loadAllAllowances as loadAllAllowancesApi,
  loadAllPaginatedAllowances as loadAllPaginatedAllowancesApi,
  createAllowance as createAllowanceApi,
  updateAllowance as updateAllowanceApi,
  deleteAllowance as deleteAllowanceApi,
  loadAllowance as loadAllowanceApi,

  loadEmployeeAllowances as loadEmployeeAllowancesApi,
  assignAllowanceToEmployee as assignAllowanceToEmployeeApi,
  deleteAllowanceFromEmployee as deleteAllowanceFromEmployeeApi,
  updateAssignedAllowance as updateAssignedAllowanceApi,
} from "../../helpers/backend_helper";
import { toast } from "react-toastify";

export const loadDeductionCategories = createAsyncThunk(
  "payroll/loadDeductionCategories",
  async (config) => {
    try {
      const response = await loadDeductionCategoriesApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

export const loadAllDeductionCategories = createAsyncThunk(
  "payroll/loadAllDeductionCategories",
  async (config) => {
    try {
      const response = await loadAllDeductionCategoriesApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

export const saveDeductionCategory = createAsyncThunk(
  "payroll/saveDeductionCategory",
  async (config) => {
    try {
      const response = await saveDeductionCategoryApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

export const loadDeductionCategory = createAsyncThunk(
  "payroll/loadDeductionCategory",
  async (config) => {
    try {
      const response = await loadDeductionCategoryApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

export const updateDeductionCategory = createAsyncThunk(
  "payroll/updateDeductionCategory",
  async (config) => {
    try {
      const response = await updateDeductionCategoryApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

export const deleteDeductionCategory = createAsyncThunk(
  "payroll/deleteDeductionCategory",
  async (config) => {
    try {
      const response = await deleteDeductionCategoryApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

// deductions
export const loadDeductions = createAsyncThunk(
  "payroll/loadDeductions",
  async (config) => {
    try {
      const response = await loadDeductionsApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

export const saveDeduction = createAsyncThunk(
  "payroll/saveDeduction",
  async (config) => {
    try {
      const response = await saveDeductionApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

// deductions
export const loadDeduction = createAsyncThunk(
  "payroll/loadDeduction",
  async (config) => {
    try {
      const response = await loadDeductionApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

export const updateDeduction = createAsyncThunk(
  "payroll/updateDeduction",
  async (config) => {
    try {
      const response = await updateDeductionApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

// deductions
export const deleteDeduction = createAsyncThunk(
  "payroll/deleteDeduction",
  async (config) => {
    try {
      const response = await deleteDeductionApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

// deduction settings

export const loadDeductionSettings = createAsyncThunk(
  "payroll/loadDeductionSettings",
  async (config) => {
    try {
      const response = await loadDeductionSettingsApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

export const addDeductionSetting = createAsyncThunk(
  "payroll/addDeductionSetting",
  async (config) => {
    try {
      const response = await addDeductionSettingApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

export const loadDeductionSetting = createAsyncThunk(
  "payroll/loadDeductionSetting",
  async (config) => {
    try {
      const response = await loadDeductionSettingApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

export const updateDeductionSetting = createAsyncThunk(
  "payroll/updateDeductionSetting",
  async (config) => {
    try {
      const response = await updateDeductionSettingApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

export const deleteDeductionSetting = createAsyncThunk(
  "payroll/deleteDeductionSetting",
  async (config) => {
    try {
      const response = await deleteDeductionSettingApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

//Assign deductions API utilities
//load all deductions categories without pagination already define with deductions Categiries API up there

export const loadAllDeductions = createAsyncThunk(
  "payroll/loadAllDeductions",
  async (config) => {
    try {
      const response = await loadAllDeductionsApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

export const loadEmployeeAssignedDeduction = createAsyncThunk(
  "payroll/loadEmployeeAssignedDeduction",
  async (config) => {
    try {
      const response = await loadEmployeeAssignedDeductionApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);
//assignDeductionToEmployee
export const assignDeductionToEmployee = createAsyncThunk(
  "payroll/assignDeductionToEmployee",
  async (config) => {
    try {
      const response = await assignDeductionToEmployeeApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

export const deleteDeductionFromEmployee = createAsyncThunk(
  "payroll/deleteDeductionFromEmployee",
  async (config) => {
    try {
      const response = await deleteDeductionFromEmployeeApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

export const disableDeductionFromEmployee = createAsyncThunk(
  "payroll/disableDeductionFromEmployee",
  async (config) => {
    try {
      const response = await disableDeductionFromEmployeeApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

//Assign Bonuses API utilities

export const loadAllBonuses = createAsyncThunk(
  "payroll/loadAllBonuses",
  async (config) => {
    try {
      const response = await loadAllBonusesApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

export const assignBonusToEmployee = createAsyncThunk(
  "payroll/assignBonusToEmployee",
  async (config) => {
    try {
      const response = await assignBonusToEmployeeApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

export const loadEmployeeAssignedBonus = createAsyncThunk(
  "payroll/loadEmployeeAssignedBonus",
  async (config) => {
    try {
      const response = await loadEmployeeAssignedBonusApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

export const deleteBonusFromEmployee = createAsyncThunk(
  "payroll/deleteBonusFromEmployee",
  async (config) => {
    try {
      const response = await deleteBonusFromEmployeeApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

export const disableBonusFromEmployee = createAsyncThunk(
  "payroll/disableBonusFromEmployee",
  async (config) => {
    try {
      const response = await disableBonusFromEmployeeApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

export const updateAssignedBonus = createAsyncThunk(
  "payroll/updateAssignedBonus",
  async (config) => {
    try {
      const response = await updateAssignedBonusApi(config);
      console.log(response);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

//////HELP LISTS//////
export const getContributionTypes = createAsyncThunk(
  "payroll/getContributionTypes",
  async () => {
    try {
      const response = await getContributionTypesApi();
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);
export const getSalaryTypes = createAsyncThunk(
  "payroll/getSalaryTypes",
  async () => {
    try {
      const response = await getSalaryTypesApi();
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

//////BACKUP///////

export const loadBackupHistory = createAsyncThunk(
  "payroll/loadBackupHistory",
  async (config) => {
    try {
      const response = await loadBackupHistoryApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

export const downloadBackup = createAsyncThunk(
  "payroll/downloadBackup",
  async (config) => {
    try {
      const response = await downloadBackupApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

export const recordBackup = createAsyncThunk(
  "payroll/recordBackup",
  async (config) => {
    try {
      const response = await recordBackupApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

export const loadPaySlipHistory = createAsyncThunk(
  "payroll/loadPaySlipHistory",
  async (config) => {
    try {
      const response = await loadPaySlipHistoryApi(config);
      console.log(response);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);
export const loadAllPaySlipHistory = createAsyncThunk(
  "payroll/loadAllPaySlipHistory",
  async (config) => {
    try {
      const response = await loadAllPaySlipHistoryApi(config);
      console.log(response);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);
export const runPayRoll = createAsyncThunk(
  "payroll/runPayRoll",
  async (config) => {
    try {
      const response = await runPayRollApi(config);
      console.log(response);
      return response;
    } catch (error) {
      console.log("error running payroll:", error.httpCode, error.message);
      toast.warn(`warning (${error.httpCode}): ${error.message}`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return Promise.reject(error);
    }
  },
);

export const loadEmployeePaySlipDetails = createAsyncThunk(
  "payroll/loadEmployeePaySlipDetails",
  async (id) => {
    try {
      const response = await loadEmployeePaySlipDetailsApi(id);
      console.log(response);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);
export const getPaySlipList = createAsyncThunk(
  "payroll/getPaySlipList",
  async (data) => {
    try {
      const response = await getPaySlipListApi(data);
      console.log(response);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

export const loadCNPSReport = createAsyncThunk(
  "payroll/loadCNPSReport",
  async (config) => {
    try {
      const response = await getCNPSReportApi(config);
      return response;
    } catch (error) {

      return Promise.reject(error);
    }
  },
);

export const generateEmployeePayslip = createAsyncThunk(
  "payroll/generateEmployeePayslip",
  async (config) => {
    try {
      const response = await generateEmployeePayslipApi(config);
      toast.success(`${response.message}`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return {
        status: 202,
        message: response.message,
      };
    } catch (error) {
      toast.error("Error generating payslip", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return Promise.reject(error);
    }
  },
);

// Bonus Settings

export const loadBonusSettings = createAsyncThunk(
  "payroll/loadBonusSettings",
  async (config, { rejectWithValue }) => {
    try {
      const response = await loadBonusSettingsApi(config);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const loadBonusSetting = createAsyncThunk(
  "payroll/loadBonusSetting",
  async (config, { rejectWithValue }) => {
    try {
      const response = await loadBonusSettingApi(config);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


//  ADD
export const addBonusSetting = createAsyncThunk(
  "payroll/addBonusSetting",
  async (config, { dispatch, rejectWithValue }) => {
    try {
      const response = await addBonusSettingApi(config);

      toast.success(response.message, {
        position: "top-right",
        autoClose: 5000,
      });
      console.log("create bonusId:", config.bonusId);
      // ✅ Refresh list
      dispatch(loadBonusSettings({ id: config.bonusId }));

      return {
        status: 202,
        message: response.message,
      };

    } catch (error) {
      toast.error("Error adding bonus setting", {
        position: "top-right",
        autoClose: 5000,
      });

      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


// ✏️ UPDATE
export const updateBonusSetting = createAsyncThunk(
  "payroll/updateBonusSetting",
  async (config, { dispatch, rejectWithValue }) => {
    try {
      const response = await updateBonusSettingApi(config);

      toast.success(response.message, {
        position: "top-right",
        autoClose: 5000,
      });
      console.log("update bonusId:", config.bonusId);
      // ✅ Refresh list
      dispatch(loadBonusSettings({ id: config.bonusId }));

      return {
        status: 202,
        message: response.message,
      };

    } catch (error) {
      toast.error("Error updating bonus setting", {
        position: "top-right",
        autoClose: 5000,
      });

      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


// 🗑 DELETE
export const deleteBonusSetting = createAsyncThunk(
  "payroll/deleteBonusSetting",
  async (config, { dispatch, rejectWithValue }) => {
    try {
      const response = await deleteBonusSettingApi(config);

      toast.success(response.message, {
        position: "top-right",
        autoClose: 5000,
      });
      console.log("delete bonusId:", config.bonusId);
      // ✅ Refresh list
      dispatch(loadBonusSettings({ id: config.bonusId }));

      return {
        status: 202,
        message: response.message,
      };

    } catch (error) {
      toast.error("Error deleting bonus setting", {
        position: "top-right",
        autoClose: 5000,
      });

      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const validatePayslips = createAsyncThunk(
  "payroll/validatePayslips",
  async (ids) => {
    try {
      const response = await validatePayslipsApi(ids);
      toast.success("Payslips validated successfully");
      return response;
    } catch (error) {
      toast.error("Failed to validate payslips");
      return Promise.reject(error);
    }
  }
);

export const rejectPayslips = createAsyncThunk(
  "payroll/rejectPayslips",
  async (ids) => {
    try {
      const response = await rejectPayslipsApi(ids);
      toast.success("Payslips rejected successfully");
      return response;
    } catch (error) {
      toast.error("Failed to reject payslips");
      return Promise.reject(error);
    }
  }
);

// Allowances
export const loadAllAllowances = createAsyncThunk(
  "payroll/loadAllAllowances",
  async () => {
    try {
      const response = await loadAllAllowancesApi();
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }
);

export const loadAllPaginatedAllowances = createAsyncThunk(
  "payroll/loadAllPaginatedAllowances",
  async (config) => {
    try {
      const response = await loadAllPaginatedAllowancesApi(config);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }
);

export const createAllowance = createAsyncThunk(
  "payroll/createAllowance",
  async (config, { dispatch, rejectWithValue }) => {
    try {
      const response = await createAllowanceApi(config);

      toast.success(response.message, {
        position: "top-right",
        autoClose: 5000,
      });

      // ✅ Refresh list
      dispatch(loadAllAllowances());

      return {
        status: 202,
        message: response.message,
      };

    } catch (error) {
      toast.error("Error creating allowance", {
        position: "top-right",
        autoClose: 5000,
      });

      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateAllowance = createAsyncThunk(
  "payroll/updateAllowance",
  async (config, { dispatch, rejectWithValue }) => {
    try {
      const response = await updateAllowanceApi(config);

      toast.success(response.message, {
        position: "top-right",
        autoClose: 5000,
      });

      // ✅ Refresh list
      dispatch(loadAllAllowances());

      return {
        status: 202,
        message: response.message,
      };

    } catch (error) {
      toast.error("Error updating allowance", {
        position: "top-right",
        autoClose: 5000,
      });

      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteAllowance = createAsyncThunk(
  "payroll/deleteAllowance",
  async (config, { dispatch, rejectWithValue }) => {
    try {
      const response = await deleteAllowanceApi(config);

      toast.success(response.message, {
        position: "top-right",
        autoClose: 5000,
      });

      // ✅ Refresh list
      dispatch(loadAllPaginatedAllowances());

      return {
        status: 202,
        message: response.message,
      };

    } catch (error) {
      toast.error("Error deleting allowance", {
        position: "top-right",
        autoClose: 5000,
      });

      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const loadAllowance = createAsyncThunk(
  "payroll/loadAllowance",
  async (config, { rejectWithValue }) => {
    try {
      const response = await loadAllowanceApi(config);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Employee Allowances
export const loadEmployeeAllowances = createAsyncThunk(
  "payroll/loadEmployeeAllowances",
  async (config, { rejectWithValue }) => {
    try {
      const response = await loadEmployeeAllowancesApi(config);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const assignAllowanceToEmployee = createAsyncThunk(
  "payroll/assignAllowanceToEmployee",
  async (config, { dispatch, rejectWithValue }) => {
    try {
      const response = await assignAllowanceToEmployeeApi(config);

      toast.success(response.message, {
        position: "top-right",
        autoClose: 5000,
      });

      // ✅ Refresh list
      dispatch(loadEmployeeAllowances(config.employeeId ));

      return {
        status: 202,
        message: response.message,
      };

    } catch (error) {
      toast.error("Error assigning allowance", {
        position: "top-right",
        autoClose: 5000,
      });

      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteAllowanceFromEmployee = createAsyncThunk(
  "payroll/deleteAllowanceFromEmployee",
  async (config, { dispatch, rejectWithValue }) => {
    try {
      const response = await deleteAllowanceFromEmployeeApi(config);

      toast.success(response.message, {
        position: "top-right",
        autoClose: 5000,
      });

      // ✅ Refresh list
      dispatch(loadEmployeeAllowances( config.employeeId));

      return {
        status: 202,
        message: response.message,
      };

    } catch (error) {
      toast.error("Error deleting allowance", {
        position: "top-right",
        autoClose: 5000,
      });

      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateAssignedAllowance = createAsyncThunk(
  "payroll/updateAssignedAllowance",
  async (config, { dispatch, rejectWithValue }) => {
    try {
      const response = await updateAssignedAllowanceApi(config);

      toast.success(response.message, {
        position: "top-right",
        autoClose: 5000,
      });

      // ✅ Refresh list
      dispatch(loadEmployeeAllowances({ id: config.employeeId }));

      return {
        status: 202,
        message: response.message,
      };

    } catch (error) {
      toast.error("Error updating allowance", {
        position: "top-right",
        autoClose: 5000,
      });

      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
